define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/comm",
	"csi/table/matrix/ColumnAssociation",
	"csi/xml"
], function(declare,_,comm,ColumnAssociation,xml) {

	var	MATRIX_GAPS = {
		SizeChartReviewActualGap: 1,
		SizeChartReviewActualRevisedGap: 1,
		SizeChartReviewGarmentShrinkage: 1,
		SizeChartReviewPatternActualGap: 1,
		SizeChartReviewSewnGarmentActualGap: 1
	};

	var	PATH_SAMPLE_DIMENSIONS_FIRST = "Child:ReviewSize/Child:ReviewSizeSamples/Index:0/Child:Dimensions";
	var	PATH_SAMPLE_DIMENSIONS_ALL = "Child:ReviewSize/Child:ReviewSizeSamples/Child:Dimensions";

	return declare(ColumnAssociation, {
		columnPath: "Child:Review/Child:ReviewSizes",
		columnAssociation: "ReviewSize",

		addDeferred: function(/*Context*/ctx, /*Heading*/h, /*Deferred[]*/dfds) {
			// summary: add deferred to get information for past reviews which includes SizeChartReviewSize, SizeChartReviewDimension, Sample, and SampleDimensions
			var dfd = ctx.cache.getNodeDependencies(ctx.view.reviewUrls, [
				"Child:ReviewSizeChart/Child:Items/Child:ReviewData",
				"Child:ReviewSizeChart/Child:SizeChartSubSizeRanges/Child:SubrangeSizeRange",
				"Child:ReviewSizes/Child:ReviewSizeSamples/Child:Dimensions"
			]);
			
			dfds.push(dfd);
		},

		addDependencyPaths: function(/*Heading*/h, /*String[]*/paths) {
			// summary: add any dependency paths necessary to process matrix
			paths.push("Child:Review/Child:ReviewSizes/Child:ReviewSizeSamples/Child:Dimensions");
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Set special css class for base size column to highlight base size column
		 */
		getColumnSpecs: function(ctx, h) {
			var specs = this.inherited(arguments);
			
			var cache = ctx.cache;
			var baseSizes = ctx.view.getViewNode().SizeChartSubSizeRanges;
			baseSizes.forEach(function(size){
				var baseSizeUrl = cache.getNode(size).BaseSize;
				specs.forEach(function(spec){
					var specSizeUrl = cache.getNode(spec.columnUrl).ReviewSize;
					if (specSizeUrl == baseSizeUrl){
						spec.css += " csi-size-base";
					}
				})
			})
			return specs;
		},
			
		_filterNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: add history to list of nodes to search for ColumnAssociation
			var	filteredNodes = this.inherited(arguments);

			if (!filteredNodes.length) {
				// iterate through SizeChartReviewDimension.History to find dimension with matching column association
				_.some(nodes, function(scrd) {
					// it is possible that we have not queried for all history nodes, so make sure to filter out the nulls
					var	historyNodes = _.filter(ctx.cache.getNodes(scrd.History), Boolean);

					filteredNodes = ColumnAssociation.prototype._filterNodes.call(this, ctx, spec, historyNodes);

					if (filteredNodes.length == 1) {
						// if the SysID matches (and thus in History), then next test for same original ApparelDimension;
						// the requirement is to support history when dimension is unlinked, but not when dimension is changed
						var	scrd2 = filteredNodes[0];
						var	scd2 = ctx.cache.getNode(scrd2.__Parent__);
						var	scd = ctx.cache.getNode(scrd.__Parent__);
						return scd.Original == scd2.Original;
					}

					return false;
				}, this);
			}

			return filteredNodes;
		},

		_getColumnNodes: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return array of nodes to be shown as columns if column matrix - return empty array if column matrix but no results
			var	cache = ctx.cache;
			var	sizes = ctx.view.getActiveSizes();
			var	reviews = ctx.view.reviewUrls;

			// reviews only supported if single size selected - reviews should be empty in that case, but just being safe
			if (reviews) {
				console.assert(sizes.length === 1);

				// for each past Review, add ReviewSize with same ProductSize as single ReviewSize column
				var	match = {ReviewSize: sizes[0].ReviewSize};

				var	reviewSizes =_.map(cache.getNodes(reviews), function(review) {
					var	reviewSize = _.findWhere(cache.getNodes(review.ReviewSizes), match);
					console.assert(!!reviewSize);
					return reviewSize;
				});

				// current review should be last in list
				sizes = reviewSizes.concat(sizes);
			}

			return sizes;
		},

		_getSpecIndices: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: doublevector attributes and gaps involving those attributes will require table cell for each entry in vector
			if ((nodes.length == 1) && ((spec.type == xml.ATTR_DOUBLEVECTOR) || (spec.type == xml.ATTR_REFVECTOR) || (MATRIX_GAPS[spec.heading.m_nameOrig]))) {
				var	n = nodes[0].Actuals.length;
				var	indices = new Array(n);

				for (var i = 0; i < n; ++i) {
					indices[i] = i;
				}

				return indices;
			}

			return null;
		},

		_getSpecNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: sample actual dimensions and gaps need to return list of SampleDimensions nodes
			if (spec.heading.m_path == PATH_SAMPLE_DIMENSIONS_FIRST) {
				return ctx.cache.getPathNodes(nodes[0], PATH_SAMPLE_DIMENSIONS_ALL);
			}

			return null;
		},

		_renderCell: function(/*Context*/ctx, /*Spec*/spec, /*Number*/nColumn, /*DOMNode*/td, /*Node[]?*/nodes, /*Number[]?*/indices) {
			// summary: force review columns to be read-only, so set all to read-only unless spec's columnUrl is that of the single selected size
			var sizes = ctx.view.getActiveSizes();
			var	bResetReadOnly;

			if (!ctx.isReadOnly() && ctx.view.reviewUrls && (spec.columnUrl != sizes[0].$URL)) {
				ctx.setReadOnly(true);
				bResetReadOnly = true;
			}

			this.inherited(arguments);

			if (bResetReadOnly) {
				ctx.setReadOnly(false);
			}
		}
	});
});